import * as TK from 'components/PDP/Details/components/Gallery/translations/constants';

export const galleryCommonLocale = {
  [TK.GALLERY_OWN_BOX_TITLE]: 'Your Box',
  [TK.GALLERY_OWN_BOX_ALT_TEXT]: 'Create your own box',
  [TK.GALLERY_OWN_BOX_CLEAR_SELECTED]: 'Clear Selected',
};
